import { createContext, useContext } from 'react'
import { HEADER_HEIGHT } from '../../constants'

export const StickyOffsetContext = createContext(HEADER_HEIGHT)
export const useStickyOffset = () => useContext(StickyOffsetContext)
